
/*
 Author: Vinod
 Date: 23/12/2019
 Issue Description: Edit option is not working to do IT declaration for an employee.
 SearchString: PL_2341
 */

<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <tl-header type="h1" class="label input-label margintop-20">IT declarations</tl-header>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="row margin-tb-m">
      <div class="col-9">
        <search-dropdown
          label="Select Employee"
          v-model="searchText"
          :employeeData="customEmpList"
          @getList="searchDataList($event)"
          @empselected="(emp)=>selectedEmp(emp)"
        />
      </div>
      <div class="col-3">
        <a
          href="javascript:void(0)"
          class="dependent-btn"
          @click="()=>{showFilter = !showFilter; subCriteriaLabel = ''}"
        >{{ !showFilter ? 'Show' :'Hide'}} Filters</a>
      </div>
    </div>
    <div class="row" v-if="showFilter">
      <div class="col-3">
        <tl-select
          label="Criteria"
          :options="criteriaList"
          @change="(val) => onSelectCriteria(val)"
        ></tl-select>
      </div>
      <div class="col-3" v-if="subCriteriaLabel">
        <tl-select
          labelText="name"
          name="sub_criteria"
          :label="subCriteriaLabel"
          :options="subCriteriaList"
        />
      </div>
      <div class="col-3" v-if="subCriteriaLabel">
        <btn text="Apply Filters" type="secondary" class="btn-filter"></btn>
      </div>
    </div>
    <div class="margintop-20">
      <data-table
        :columns="tableColumns"
        :tableData="declarationsData"
        :checkbox="true"
        :showinrow="false"
        :icons="[{url:require('@/assets/logout-copy-2.png'), method: 'down'}
                   ]"
        :showinheader="false"
      >
        <template v-slot:rowcontent="slotprops">
          <!-- <img
            class="sm-img"
            v-if="slotprops.value.column.key=='imgSrc'"
            :src="slotprops.value.record[slotprops.value.column.key]"
          />-->
          <p
            :id="slotprops.value.index+slotprops.value.column.key"
            v-if="slotprops.value.column.key!='imgSrc'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <span
            class="row-container action-img align-center"
            v-if="slotprops.value.column.key=='action'"
          >
            <img :src="require('@/assets/download.svg')" alt="download" />
            <span class="grey-divider" />
            <img :src="require('@/assets/logout-copy-2.png')" alt="upload" />
            <span class="grey-divider" />
            <img
              :src="require('@/assets/document.svg')"
              alt="view"
              @click="editDeclaration(slotprops.value.record)"
            />
          </span>
          <!-- <div class="action-section" v-if="slotprops.value.column.key=='action'">
            <img class="menu-icon" src="@/assets/group-2.png" alt="actionIcon" />
            <ul class="action-menu">
              <li @click="editDeclaration(slotprops.value.record)">
                <span class>View/Edit Declaration</span>
              </li>
              <li @click="importDeclaration()">
                <span class>Import Declaration</span>
              </li>
              <li @click="exportDeclaration()">
                <span class>Export Declaration</span>
              </li>
            </ul>
          </div>-->
        </template>
      </data-table>
    </div>
    <article>
      <bottom-action-container>
        <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" />
            <btn text="Save" type="primary" @click="$emit('nextStep', 3)" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </article>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import {
  monthOptionsObj,
  criteriaObj
} from "../../../../../../../apis/constants.js";
export default {
  components: {
    SearchDropdown
  },
  data() {
    return {
      search: "",
      code: "",
      searchText: "",
      errmsg: "",
      toast: false,
      legalEntityList: [],
      customEmpList: [],
      showDropDown: [],
      criteriaList: criteriaObj.paygroupCriteria,
      subCriteriaList: [],
      subCriteriaLabel: "",
      showFilter: false,
      selectedFilterData: {},
      breadcrumbList: [
        {
          name: "Organisation",
          url: `/dashboard/${this.$route.params.entity_index}/organisation`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/`
        },
        {
          name: "IT declarations",
          url: ""
        }
      ],
      tableColumns: [
        {
          label: "",
          key: "imgSrc"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Department",
          key: "department"
        },
        {
          label: "Email ID",
          key: "email_id"
        },
        {
          label: "Location",
          key: "location"
        },
        {
          label: "",
          key: "action"
        }
      ],
      months: monthOptionsObj.onlyMonths,
      declarationsData: [],
      submissionStartMonth: "",
      submissionStartDay: "",
      submissionEndMonth: "",
      declarationStartMonth: "",
      submissionEndYear: null,
      submissionStartYear: null
    };
  },
  activated() {
    this.criteriaList[4] = "Paygroup";
    this.fetchitsettings();
  },
  computed: {
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    }
  },
  methods: {
    ...mapActions({
      fetchEmployees: "globalapi/globalemployees/fetchAll",
      fetchEmployeeByName: "globalapi/globalemployees/fetchByName",
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_locations: "onboard/locations/fetchAll",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_businessunits: "onboard/business_units/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll",
      fetch_it_settings: "onboard/statutoryinfo/incometax/fetchAll"
    }),

    searchDataList(val) {
      this.getEmployeesByName(val);
    },
    selectedEmp(val) {
      this.declarationsData = [val];
    },

    // version 1.1 codes
    async fetchitsettings() {
      try {
        let res = await this.fetch_it_settings(this.le_id);
        let obj = res.data.payload.data;
        let d1 = new Date(obj.submissionSettings.submissionStartDate);
        let d2 = new Date(obj.submissionSettings.submissionEndDate);
        this.submissionStartDay = d1.getDate();
        this.submissionStartMonth = d1.getMonth();
        this.submissionStartYear = d1.getFullYear();
        this.submissionEndMonth = d2.getMonth();
        this.submissionEndYear = d2.getFullYear();
        this.declarationStartMonth = this.months.indexOf(
          obj.declarationSettings.declarationStartMonth
        );
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    editDeclaration(rowData) {
      try {
        let date = new Date();
        let currentMonth = date.getMonth();
        let currentYear = date.getFullYear();
        let currentDay = date.getDate();
        if (
          this.submissionStartMonth >= currentMonth &&
          currentDay >= this.submissionStartDay &&
          ((currentYear == this.submissionEndYear &&
            currentMonth <= this.submissionEndMonth) ||
            (currentYear < this.submissionEndYear &&
              currentMonth >= this.submissionEndMonth))
        ) {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/editActualdeclaration`,
            query: { id: rowData.id }
          });
        }
        if (
          this.declarationStartMonth <= currentMonth &&
          ((currentYear == this.submissionStartYear &&
            currentMonth <= this.submissionStartMonth) ||
            (currentYear < this.submissionStartYear &&
              currentMonth >= this.submissionStartMonth)) &&
          ((currentYear == this.submissionStartYear &&
            currentDay <= this.submissionStartDay) ||
            (currentYear < this.submissionStartYear &&
              currentDay >= this.submissionStartDay))
        ) {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/editdeclaration`,
            query: { id: rowData.id }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async getLocations() {
      try {
        let res = await this.fetch_locations(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getBands() {
      try {
        let res = await this.fetch_bands(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getDepartment() {
      try {
        let res = await this.fetch_businessunits(
          this.orgData ? this.orgData.id : ""
        );
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getDesignations() {
      try {
        let res = await this.fetch_designation(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    onSelectCriteria(event) {
      try {
        if (event == "Location") {
          this.subCriteriaLabel = "Location";
          this.getLocations();
        } else if (event == "Paygroup") {
          this.subCriteriaLabel = "Paygroup";
          this.getPaygroups();
        } else if (event == "Cost Centre") {
          this.subCriteriaLabel = "Cost Centre";
          this.getCostCenter();
        } else if (event == "Salary Band") {
          this.subCriteriaLabel = "Salary Band";
          this.getBands();
        } else if (event == "Grade") {
          this.subCriteriaLabel = "Grade";
          this.getGrades();
        } else if (event == "Designations") {
          this.subCriteriaLabel = "Designations";
          this.getDesignations();
        } else {
          this.subCriteriaLabel = "Sub Criteria";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    // end
    async getEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.le_id,
          key: val
        });
        this.customEmpList = res.data.payload;
      } catch (error) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    importDeclaration() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/importdeclarations`
      });
    },
    exportDeclaration() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/exportdeclarations`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.flex-container {
  display: flex;
  align-items: center;
}
.flex-container > div {
  margin-right: 10px;
}
.custom-width {
  width: 300px;
}
.sm-img {
  width: 35%;
}
.show {
  display: block;
}
.action-section:hover {
  .action-menu {
    display: block;
  }
}
.action-section {
  display: inline-block;
  margin-left: 15px;
  text-align: center;

  img {
    width: auto;
  }

  .action-menu {
    display: none;
    top: 0%;
    left: -225px;
    right: 0;
    width: max-content;
    padding-top: 5px;
    padding-bottom: 5px;
    li {
      padding: 0px;
      font-weight: 500;
      span {
        margin: 0px 20px;
        padding: 10px;
        display: block;
      }
      &:not(:last-child) {
        span {
          border-bottom: solid 1px #97979759;
        }
      }
    }
  }
}
.dependent-btn {
  float: right;
  color: #37c6c0;
  font-weight: 600;
  margin-top: 15px;
  font-size: 14px;
  text-decoration: none;
}
.btn-filter {
  margin-top: 20px;
  padding: 0px;
  min-height: 35px;
}
</style>

